// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popper[data-v-d4f5b66c] {\n  margin-top: 3px;\n}\n.el-dropdown[data-v-d4f5b66c] {\n  margin-right: 20px;\n}\n.el-dropdown-link[data-v-d4f5b66c] {\n  cursor: pointer;\n  font-size: 16px;\n  color: #666;\n}\n.mgr5[data-v-d4f5b66c] {\n  margin-right: 3px;\n}\n.lang-dropdown[data-v-d4f5b66c] {\n  padding: 1px;\n}", ""]);
// Exports
module.exports = exports;
